import { useState } from 'react';
import api from '../../../../services/api';

const EXPOSURE_LABELS = {
  dedicated: 'Dedicada',
  shared: 'Compartilhada',
  mention: 'Citação',
  none: 'Sem exposição'
};

const useArticleModalExposureActions = ({
  localArticle,
  setLocalArticle,
  showSnackbar
}) => {
  const [exposureAnalyzing, setExposureAnalyzing] = useState(false);

  const handleUpdateExposure = async (exposure) => {
    const previousExposure = localArticle.exposure;
    try {
      setLocalArticle(prev => ({ ...prev, exposure }));
      await api.put(`/articles/${localArticle._id}/exposure`, { exposure });
      showSnackbar(`Exposição definida: ${EXPOSURE_LABELS[exposure] || exposure}`);
    } catch (error) {
      setLocalArticle(prev => ({ ...prev, exposure: previousExposure }));
      console.error('Erro ao atualizar exposição:', error);
      showSnackbar('Erro ao atualizar exposição.');
    }
  };

  const handleAnalyzeExposure = async () => {
    if (!localArticle?._id || exposureAnalyzing) return;
    setExposureAnalyzing(true);
    try {
      const response = await api.post(`/articles/${localArticle._id}/analyze-exposure`, { forceAI: true });
      const result = response.data;
      if (result.success && result.data?.exposure) {
        setLocalArticle(prev => ({
          ...prev,
          exposure: result.data.exposure,
          exposureAnalysis: result.analysis || result.data.exposureAnalysis || prev.exposureAnalysis,
          exposureConfidence: result.data.exposureConfidence || prev.exposureConfidence
        }));
        const competitors = result.analysis?.competitorAnalysis?.length > 0
          ? ` | Concorrentes: ${result.analysis.competitorAnalysis.map(c => c.competitor).join(', ')}`
          : '';
        const source = result.source === 'ai' ? 'via IA' : 'via regras';
        showSnackbar(`Exposição: ${EXPOSURE_LABELS[result.data.exposure] || result.data.exposure} (${source})${competitors}`);
      } else {
        showSnackbar(result.message || 'Sem briefing configurado ou nenhuma keyword encontrada');
      }
    } catch (error) {
      console.error('Erro ao analisar exposição:', error);
      showSnackbar('Erro ao analisar exposição. Verifique se o briefing está configurado.');
    } finally {
      setExposureAnalyzing(false);
    }
  };

  return {
    exposureAnalyzing,
    handleAnalyzeExposure,
    handleUpdateExposure
  };
};

export default useArticleModalExposureActions;
